// removed by extract-text-webpack-plugin
module.exports = {"Header":"Header__-loca-__364Zo","MenuToggle":"Header__-loca-__1GAnZ","Title":"Header__-loca-__221Sn","Link":"Header__-loca-__26Pyj"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Header/Header.css
// module id = 168
// module chunks = 0